import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const richiesteFiltersSlice = createSlice({
  name: "richiesteFilters",
  initialState,
  reducers: {
    setRichiesteFilters: (state, action) => action.payload,
    clearRichiesteFilters: () => null,
  },
});

export const { setRichiesteFilters, clearRichiesteFilters } =
  richiesteFiltersSlice.actions;
export default richiesteFiltersSlice.reducer;
